(function (root) {
  'use strict';
  function transform(query, predictive) {
    if (!query || /\b(?:OR|AND|NOT)\b/.test(query)) return query;
    return query.replace(/(?<![\w/.,-])(\d{1,2})[.,\/-](\d{1,3})(?![\w/.,-])/g, function (match, a, b, offset) {
      const before = query.slice(0, offset), after = query.slice(offset + match.length);
      if (/(?:\b(?:RON|HUF|EUR|USD|lei|Ft)|[€$£])\s*$/i.test(before) || /^\s*(?:RON\b|HUF\b|EUR\b|USD\b|lei\b|Ft\b|[€$£]|ml\b|kg\b|g\b|cm\b|mm\b|%)/i.test(after)) return match;
      return predictive ? a + '/' + b : '(' + a + '.' + b + ' OR ' + a + '/' + b + ' OR ' + a + '-' + b + ' OR ' + a + ',' + b + ')';
    });
  }
  const normalizeBrand = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const aliases = {wella: 'wellaprofessionals', wellaprofessional: 'wellaprofessionals', loreal: 'lorealprofessionnel', lorealprofessional: 'lorealprofessionnel', alfaparfmilano: 'alfaparf', babyliss: 'babylisspro', londaprofessional: 'londa', londaprofessionals: 'londa'};
  function brandLanding(query, searchPath, routes) {
    const normalized = normalizeBrand(query);
    if (!normalized) return null;
    const key = aliases[normalized] || normalized;
    const route = routes.find(item => normalizeBrand(item.name) === key || normalizeBrand(item.key) === key);
    if (!route || !/^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?collections\/[^/?#]+$/.test(route.url)) return null;
    const prefix = searchPath.replace(/\/search\/?$/, '');
    return prefix && route.url.startsWith('/collections/') ? prefix + route.url : route.url;
  }
  root.pbShadeSearch = { expand: q => transform(q, false), predictive: q => transform(q, false), brandLanding };
  if (typeof document === 'undefined') return;
  let brandRoutes = [];
  try { brandRoutes = JSON.parse(document.getElementById('pb-search-brand-routes')?.textContent || '[]'); } catch (_) {}
  if (!Array.isArray(brandRoutes)) brandRoutes = [];
  const key = q => 'pb-shade-query:' + q;
  function remember(q, original) { try { sessionStorage.setItem(key(q), original); } catch (_) {} }
  function recall(q) { try { return sessionStorage.getItem(key(q)); } catch (_) { return null; } }
  const current = new URL(location.href);
  if (/\/search\/?$/.test(current.pathname)) {
    const q = current.searchParams.get('q') || '', expanded = transform(q, false);
    const landing = brandLanding(q, current.pathname, brandRoutes);
    if (landing) { location.replace(landing); return; }
    if (expanded !== q) { remember(expanded, q); current.searchParams.set('q', expanded); location.replace(current.href); return; }
  }
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const url = new URL(form.action, location.href);
    if (url.origin !== location.origin || !/\/search\/?$/.test(url.pathname)) return;
    const data = new FormData(form), original = data.get('q');
    if (typeof original !== 'string') return;
    const landing = brandLanding(original, url.pathname, brandRoutes);
    if (landing) { event.preventDefault(); event.stopImmediatePropagation(); location.assign(landing); return; }
    const expanded = transform(original, false);
    if (expanded === original) return;
    event.preventDefault(); event.stopImmediatePropagation();
    remember(expanded, original); data.set('q', expanded);
    url.search = new URLSearchParams(data).toString(); location.assign(url.href);
  }, true);
  function restoreLabels() {
    const q = new URL(location.href).searchParams.get('q'), original = q && recall(q);
    if (!original || original === q) return;
    document.querySelectorAll('input[name="q"]:not([type="hidden"])').forEach(input => { if (input.value === q) input.value = original; });
    const main = document.querySelector('main'); if (!main) return;
    const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT); let node;
    while ((node = walker.nextNode())) {
      if (!node.parentElement.closest('script,style,textarea') && node.nodeValue.includes(q)) node.nodeValue = node.nodeValue.split(q).join(original);
    }
    if (document.title.includes(q)) document.title = document.title.split(q).join(original);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreLabels); else restoreLabels();
  document.addEventListener('shopify:section:load', restoreLabels);
})(typeof window === 'undefined' ? globalThis : window);
